import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Interview from './Interview';
import ApprovePage from './ApprovePage';
import MeetingPage from './MeetingPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
const path = window.location.pathname;

if (path === '/interview' || path === '/bench-interview') {
  root.render(<Interview />);
} else if (path === '/approve') {
  root.render(<ApprovePage />);
} else if (path === '/meet') {
  root.render(<MeetingPage />);
} else {
  root.render(<App />);
}
